import * as actionsTypes from "./actionTypes";
const initialState = {
  serviceList: [],
};
export default function userData(state = initialState, action) {
  switch (action.type) {
    case actionsTypes.SET_SERVICE_TYPES:
      return { ...state, serviceList: action.payload };
    default:
      return state;
  }
}
